/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'mat_outline:dashboard',
        link : '/dashboard'
    },
    {
        id   : 'abnormal',
        title: 'Issues',
        type : 'basic',
        icon : 'mat_outline:apps',
        link : '/issues'
    },
    {
        id   : 'reporting',
        title: 'Reports',
        type : 'basic',
        icon : 'heroicons_outline:document-chart-bar',
        link : '/reporting'
    },
    {
        id   : 'team',
        title: 'Team',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/team'
    },
    {
        id   : 'constant',
        title: 'Constant',
        type : 'basic',
        icon : 'heroicons_outline:variable',
        link : '/constant'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
